import React, { useEffect, useState } from 'react';
import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import { LanguageContext } from '../contexts/LanguageContext';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Divider, Grid2 } from '@mui/material';
import { globalBuilder } from '../../archbuilder/GlobalBuilder';

export const ContactMe: React.FC = () => {
  const { theme, setThemes } = useContext(ThemeContext);
  const [themeIconColor, setThemeIconColor] = useState('black');
  const { t } = useContext(LanguageContext);
  const listIconSize = 30;

  useEffect(() => {
    setThemes(['pages', 'elementcards']);
  }, []);

  useEffect(() => {
    setThemeIconColor(
      theme === 'light'
        ? 'black'
        : theme === 'dark'
          ? 'white'
          : theme === 'thief'
            ? 'black'
            : 'black',
    );
  }, [theme]);

  return globalBuilder.ContactMe(listIconSize, themeIconColor);
};
